import React, { Component } from "react";
import GeneralBloc from "../../../bloc/general_bloc";
import "./client_details_screen.css";
import { Input, Button, Form, Row, Col, Typography, InputNumber } from "antd";
import { EditOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined, IdcardOutlined } from "@ant-design/icons";
import AppFieldError from "../../component/form/app_field_error/app_field_error";
import RouteBloc from "../../../bloc/route_bloc";
import Config from "../../../Config";
import config from "../../../data/constant/config";
import UtilBloc from "../../../bloc/util_bloc";
import AuthBloc from "../../../bloc/auth_bloc";
import { Redirect, withRouter } from "react-router-dom";
import Labels from "../../constant/labels";
import LanguageBloc from "../../../bloc/language_bloc";
import AppLoadingDialog from "../../dialog/app_loading_dialog";
import AppDialog from "../../component/app_dialog/app_dialog";
import App_loading_dialog from "../../dialog/app_loading_dialog";
import AdminBloc from "../../../bloc/admin_bloc";
import BaseScreen from "../base/base_screen/base_screen";
import CryptoService from "../../../service/crypto_service";
const { Text } = Typography;

//LoginScreen
class ClientDetailsScreen extends Component {
  constructor(props) {
    super(props);
    let routeParams = RouteBloc.extractRouteParamsFromProps(props);
    this.state = {
      client: Config.context,
      route: routeParams,
      loaded: true,
      loading: true,
      seconds_remain: 59,
      minutes_remain: 9,
      remain: null,
      type: props.match.params.type,
      action: props.match.params.action,
      clientDetails: null,
      oldClientDetails: null,
      validated: false,
      validations: {},
    };
    //this.loadLabels();
    /* localStorage.removeItem("PRUESUB_SELECTED_LANG");
    sessionStorage.removeItem("verifiedOtp");
    sessionStorage.removeItem("dataUser");
    sessionStorage.removeItem("otpVerificationMethod"); */
  }

  stateType() {
    return this.state.type;
  }

  stateAction() {
    return this.state.action;
  }

  stateValidations() {
    return this.state.validations;
  }

  stateValidated() {
    return this.state.validated
  }

  stateFields() {
    return [
      "memberMobile",
      "memberEmail",
      "memberAddress"
    ]
  }

  validateMemberDetails(data) {   
    const isValidMobile = /^\+?\d+$/.test(data.memberMobile);
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.memberEmail); // Valid email format
    const hasValidAddress =
      data.address1?.trim() && data.postcode?.trim(); // Check if address1 and postcode have values

    return {
      memberMobile: isValidMobile,
      memberEmail: isValidEmail,
      memberAddress: Boolean(hasValidAddress)
    };
  }

  onValidate() {
    let validated = true;
    this.stateFields().map((field) => {
      //console.log("IDDDDDCOMPANY", field);
      //console.log("IDDDDDCOMPANY1", this.stateValidations()[field]);
      validated = validated && (this.stateValidations()[field] || false);
    });
    this.setState({
      validated
    })
  }

  updateFieldValidationStatus(field, validated) {
    let validation = this.stateValidations();
    // Update the validation status
    validation[field] = validated;
    this.setState({
      validations: validation,
    }, () => {
      this.onValidate();
    });
  }

  clearAllTimeouts() {
    Object.values(this.timeoutIds).forEach(clearTimeout);
    this.timeoutIds = {}; // Clear the object after clearing all timeouts
  }


  stateClientDetails() {
    return this.state.clientDetails
  }

  redirectToLogin() {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = `/${this.state.client}/${Config.routes.generic.login}`;
  }

  async getClientInformation() {
    await AdminBloc.getClientInformation().then((result) => {
      let data = result.data;
      //data.memberMobile="";
      //data.memberEmail="";
      let validations = this.validateMemberDetails(data)
      //console.log("validations", validations)
      if (this.stateAction() == "view") {
        validations = {
          memberMobile: true, memberEmail: true, memberAddress: true, memberTaxId: true
        }
      }
      //console.log("DDSDSD", data)
      if (result.success) {
        this.setState({
          validations,
          clientDetails: data,
          oldClientDetails: data,
          loading: false,
          loaded: true,
        }, () => {
          this.onValidate()
        })
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode: result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      }, () => {
        this.redirectToLogin();
      })
    })
  }

  async getEditClientInformation() {
    await AdminBloc.getEditClientInformation().then((result) => {
      let data = result.data;
      //data.memberMobile="";
      //data.memberEmail="";
      let validations = this.validateMemberDetails(data)
      //console.log("validations", validations)
      if (this.stateAction() == "view") {
        validations = {
          memberMobile: true, memberEmail: true, memberAddress: true, memberTaxId: true
        }
      }
      
      if (result.success) {
        this.setState({
          validations,
          clientDetails: data,
          oldClientDetails: data,
          loading: false,
          loaded: true,
        }, () => {
          this.onValidate()
        })
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode: result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      }, () => {
        this.redirectToLogin();
      })
    })
  }

  async getMemberDetailsInformation() {
    await AdminBloc.getMemberDetailsEditInformation().then((result) => {

      let data = result.data
      data.correspondenceAddress = [
        data.address1,
        data.address2,
        data.address3,
        data.address4,
        data.postcode
      ]
        .filter(Boolean) // Remove undefined, null, or empty strings
        .join(", ");
      let validations = this.validateMemberDetails(data)
      if (this.stateAction() == "view") {
        validations = {
          memberMobile: true, memberEmail: true, memberAddress: true, memberTaxId: true
        }
      }

      if (result.success && data) {
        this.setState({
          validations,
          clientDetails: data,
          oldClientDetails: data,
          loading: false,
          loaded: true
        }, () => {
          this.onValidate()
        })
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode: result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      }, () => {
        this.redirectToLogin();
      })
    })
  }

  componentDidMount() {
    if (this.stateType() == "member") {
      this.getMemberDetailsInformation();
    } else {
      if(this.stateAction() == "edit"){
        this.getEditClientInformation();
      } else {
        this.getClientInformation();
      }      
    }
  }

  componentWillUnmount() {
    clearInterval(this.myIntervalErrorOtp);
  }

  loadingContent() {
    return (
      <div style={{ height: "100%", width: "100%" }}>
        <AppLoadingDialog isLoading={this.state.loading} />
      </div>
    );
  }

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  editClientDetails() {
    return <div className="col-md-6">
      {/* Mobile No */}
      <div className="mb-3 d-flex align-items-center">
        <PhoneOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div style={{ flex: 1 }}>
          <span className="text-muted"><span style={{ color: "red" }}>*</span> Mobile no. / <i>No. Telefon Bimbit</i></span>
          <InputNumber
            placeholder=""
            controls={false}
            maxLength={12}
            className="fw-bold"
            addonBefore="+60"
            style={{ width: "100%", border: "0.5px solid #808ea8" }} // Makes the number bold
            value={this.stateClientDetails()?.["memberMobile"]}            
            onKeyPress={(event) => {
              const charCode = event.which || event.keyCode;
              const inputValue = event.target.value;
              // Allow only numeric keys and control keys (e.g., backspace)
              if (
                !/[0-9]/.test(String.fromCharCode(charCode)) &&
                charCode !== 8
              ) {
                event.preventDefault();
              }
            }}
            onChange={(value) => {
              this.setState({ errorMobileNo: "" });
              this.updateFieldValidationStatus("memberMobile", false);
              this.setState((prevState) => ({
                clientDetails: {
                  ...prevState.clientDetails,
                  memberMobile: value,
                },
              }));
              
              if (!value){                
                this.setState({ errorMobileNo: "This field can not be empty" });
                return;
              }
              this.updateFieldValidationStatus("memberMobile", true);
            }}
          />

          {this.state.errorMobileNo && (
            <div style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
              {this.state.errorMobileNo}
            </div>
          )}
        </div>
      </div>



      {/* Email */}
      <div className="mb-3 d-flex align-items-center">
        <MailOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div style={{ flex: 1 }}>
          <span className="text-muted"><span style={{ color: "red" }}>*</span> Email / <i>Emel</i></span>
          <Input
            placeholder=""
            className="fw-bold"
            maxLength={30}
            value={this.stateClientDetails()?.["memberEmail"]}
            onChange={(e) => {
              this.setState({ emailError: "" });
              this.updateFieldValidationStatus("memberEmail", false);
              const updatedValue = e.target.value;
              this.setState((prevState) => ({
                clientDetails: {
                  ...prevState.clientDetails,
                  memberEmail: updatedValue,
                },
              }));
              if (!updatedValue || !this.validateEmail(updatedValue)) {
                this.setState({ emailError: "Please enter a valid email address." });
                return;
              }
              this.updateFieldValidationStatus("memberEmail", true);
            }}
          />
          {this.state.emailError && (
            <div style={{ color: "red", marginTop: "5px", fontSize: "12px" }}>
              {this.state.emailError}
            </div>
          )}
        </div>
      </div>

      {/* Address */}
      {/* Address */}
      <div className="mb-2 d-flex align-items-start">
        <EnvironmentOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div>
          <span className="text-muted">
            <span style={{ color: "red" }}>*</span> Correspondence address / <i>Alamat Surat-menyurat</i>
          </span>
          <div className="fw-bold">
            <Input
              placeholder=""
              maxLength={90}
              className="mb-2 fw-bold"
              value={this.stateClientDetails()?.["address1"]}
              onChange={(e) => {
                this.setState({ errorAddress1: "" });
                this.updateFieldValidationStatus("memberAddress", false);
                const updatedValue = e.target.value;
                this.setState((prevState) => ({
                  clientDetails: {
                    ...prevState.clientDetails,
                    address1: updatedValue, // Update the specific field dynamically
                  },
                }));
                if (UtilBloc.isNullOrEmpty(updatedValue)) {
                  this.setState({ errorAddress1: "This field can not be empty" });
                  return;
                }
                if (!this.state.errorCityState && !this.state.errorPostcode) {
                  this.updateFieldValidationStatus("memberAddress", true);
                }

              }}
            />
            {this.state.errorAddress1 && (
              <div style={{ color: "red", marginBottom: "6px", fontSize: "12px" }}>
                {this.state.errorAddress1}
              </div>
            )}
            <Input placeholder="" className="mb-2 fw-bold"
              maxLength={90}
              value={this.stateClientDetails()?.["address2"]}
              onChange={(e) => {
                const updatedValue = e.target.value;
                this.setState((prevState) => ({
                  clientDetails: {
                    ...prevState.clientDetails,
                    address2: updatedValue, // Update the specific field dynamically
                  },
                }));
              }}
            />
            <Input placeholder="" className="mb-2 fw-bold"
              maxLength={90}
              value={this.stateClientDetails()?.["address3"]}
              onChange={(e) => {
                const updatedValue = e.target.value;
                this.setState((prevState) => ({
                  clientDetails: {
                    ...prevState.clientDetails,
                    address3: updatedValue, // Update the specific field dynamically
                  },
                }));
              }}
            />
            <div>
              <div className="text-muted">
                <span style={{ color: "red" }}>*</span> City, State / <i>Bandar, Negeri</i>
              </div>
              <Input placeholder="" className="mb-2 fw-bold"
                maxLength={90}
                value={this.stateClientDetails()?.["address4"]}
                onChange={(e) => {
                  this.setState({ errorCityState: "" });
                  this.updateFieldValidationStatus("memberAddress", false);
                  const updatedValue = e.target.value;
                  this.setState((prevState) => ({
                    clientDetails: {
                      ...prevState.clientDetails,
                      address4: updatedValue, // Update the specific field dynamically
                    },
                  }));
                  if (UtilBloc.isNullOrEmpty(updatedValue)) {
                    this.setState({ errorCityState: "This field can not be empty" });
                    return;
                  }
                  if (!this.state.errorAddress1 && !this.state.errorPostcode) {
                    this.updateFieldValidationStatus("memberAddress", true);
                  }

                }}
              />
              {this.state.errorCityState && (
                <div style={{ color: "red", marginBottom: "6px", fontSize: "12px" }}>
                  {this.state.errorCityState}
                </div>
              )}
            </div>


            <div>
              <div className="text-muted">
                <span style={{ color: "red" }}>*</span> Postcode / <i>Poskod</i>
              </div>
              <Input placeholder="" className="mb-2 fw-bold"
                maxLength={90}
                value={this.stateClientDetails()?.["postcode"]}
                onChange={(e) => {
                  this.setState({ errorPostcode: "" });
                  this.updateFieldValidationStatus("memberAddress", false);
                  const updatedValue = e.target.value;
                  this.setState((prevState) => ({
                    clientDetails: {
                      ...prevState.clientDetails,
                      postcode: updatedValue, // Update the specific field dynamically
                    },
                  }));
                  if (UtilBloc.isNullOrEmpty(updatedValue)) {
                    this.setState({ errorPostcode: "This field can not be empty" });
                    return;
                  }
                  if (!this.state.errorAddress1 && !this.state.errorCityState) {
                    this.updateFieldValidationStatus("memberAddress", true);
                  }
                }}
              />
              {this.state.errorPostcode && (
                <div style={{ color: "red", marginBottom: "6px", fontSize: "12px" }}>
                  {this.state.errorPostcode}
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

      {/* TIN No */}
      <div className="mb-4 d-flex align-items-center">
        <IdcardOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div style={{ flex: 1 }}>
          <span className="text-muted">Tin no. / <i>No. Pengenalan Cukai</i></span>
          <Input
            placeholder=""
            maxLength={15}
            className="fw-bold"
            value={this.stateClientDetails()?.["memberTaxId"]}
            onChange={(e) => {
              this.updateFieldValidationStatus("memberTaxId", false);
              const updatedValue = e.target.value;
              this.setState((prevState) => ({
                clientDetails: {
                  ...prevState.clientDetails,
                  memberTaxId: updatedValue,
                },
              }));
              if (!updatedValue) return;
              this.updateFieldValidationStatus("memberTaxId", true);
            }}
          />
        </div>
      </div>
    </div>
  }

  displayClientDetails() {
    return <div className="col-md-6">
      {/* Mobile No */}
      <div className="mb-2 d-flex align-items-center">
        <PhoneOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div>
          <span className="text-muted"><span style={{ color: "red" }}>*</span> Mobile no. / <i>No. Telefon Bimbit</i></span>
          <div className="fw-bold">
            {
              this.stateClientDetails()?.memberMobile ? "+60"+this.stateClientDetails()?.memberMobile.slice(0, -4) + "****" : "-"
            }
          </div>
        </div>
      </div>

      {/* Email */}
      <div className="mb-2 d-flex align-items-center">
        <MailOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div>
          <span className="text-muted"><span style={{ color: "red" }}>*</span> Email / <i>Emel</i></span>
          <div className="fw-bold">
            {
              this.stateClientDetails()?.memberEmail ? this.stateClientDetails()?.memberEmail.replace(/.{4}(?=@)/, "****") : "-"
            }
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="mb-2 d-flex align-items-start">
        <EnvironmentOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div>
          <span className="text-muted"><span style={{ color: "red" }}>*</span> Correspondence address / <i>Alamat Surat-menyurat</i></span>
          <div className="fw-bold">
            {
              this.stateClientDetails()?.correspondenceAddress ? this.stateClientDetails()?.correspondenceAddress : "-"
            }
          </div>
        </div>
      </div>

      {/* TIN No */}
      <div className="mb-4 d-flex align-items-center">
        <IdcardOutlined style={{ fontSize: "38px", marginRight: "8px" }} />
        <div>
          <span className="text-muted">Tin no. / <i>No. Pengenalan Cukai</i></span>
          <div className="fw-bold">
            {
              this.stateClientDetails()?.memberTaxId ? this.stateClientDetails()?.memberTaxId.slice(0, -4) + "****" : "-"
            }
          </div>
        </div>
      </div>
    </div>
  }

  leftContentDependOnTypeClient() {
    if (this.stateType() == "member") {
      return <div>
        <div>
          <div>Name / <em>Nama</em></div>
          <strong>
            {
              this.stateClientDetails()?.memberName
            }
          </strong>
        </div>
        <div>
          <div>NRIC no. / <em>No. Kad Pengenalan</em></div>
          <strong>
            {
              this.stateClientDetails()?.memberId
            }
          </strong>
        </div>
        <div>
          <div>Date of Birth / <em>Tarikh Lahir</em></div>
          <div>
            <strong>
              {
                this.stateClientDetails()?.memberDob
              }
            </strong>
          </div>
        </div>
      </div>
    } else {
      return <div className="mb-2">
        <span className="text-muted">Takaful Certificate Schedule no. / <i>No. Jadual Sijil Takaful</i></span>
        <div className="fw-bold">
          {
            this.stateClientDetails()?.certificateNo
          }
        </div>
      </div>

    }
  }

  titleDependOnTypeClient() {
    if (this.stateType() == "member") {
      return <div>
        <h5 className="fw-bold">Member Details / <i><strong>Butiran Ahli</strong></i></h5>
      </div>
    } else {
      return <div>
        <h5 className="fw-bold">CUEPACSCare Scheme</h5>
      </div>
    }
  }

  async saveClientInformation() {
    this.setState({
      loading: true
    })
    let payload = this.stateClientDetails();

    payload.correspondenceAddress = [
      payload.address1,
      payload.address2,
      payload.address3,
      payload.address4,
      payload.postcode
    ]
      .filter(Boolean) // Remove undefined, null, or empty strings
      .join(", ");
    payload.memberMobile="+60"+payload.memberMobile;
    await AdminBloc.saveClientInformation(payload).then((result) => {
      if (result.success) {
        window.location.href = `/${this.state.client}/${Config.routes.generic.successful_registration}/updated`;
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode: result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      }, () => {
        this.redirectToLogin()
      })
    })
  }

  async saveMemberInformation() {
    this.setState({
      loading: true
    })
    let payload = this.stateClientDetails();

    payload.correspondenceAddress = [
      payload.address1,
      payload.address2,
      payload.address3,
      payload.address4,
      payload.postcode
    ]
      .filter(Boolean) // Remove undefined, null, or empty strings
      .join(", ");
    payload.memberMobile="+60"+payload.memberMobile;
    await AdminBloc.saveMemberInformation(payload).then((result) => {
      if (result.success) {
        window.location.href = `/${this.state.client}/${Config.routes.generic.successful_registration}/updated`;
      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode: result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      }, () => {
        this.redirectToLogin()
      })
    })
  }

  encryptionData(data) {
    let RequestId = "";
    let encryptionPromise = Promise.resolve("");
    encryptionPromise = CryptoService.encrypt(data, process.env.REACT_APP_ENCRYTION_PASS);
    return encryptionPromise.then(encryptedData => {
      RequestId = encryptedData;
      return RequestId
    });
  }

  async requestOTP() {
    this.setState({
      loading: true
    })
    let payload = {
      "certId": AuthBloc.getCertificateNo(),
      "mbrId": AuthBloc.getNRICNo()
    };

    await AdminBloc.requestOTP(payload).then(async (result) => {
      //console.log("OTP Result", result)
      if (result.success) {
        let otpObject = await this.encryptionData(JSON.stringify(result.data))
        sessionStorage.setItem("otpObject", otpObject)
        if (result.data?.mfaChallengeType == "sms") {
          sessionStorage.setItem("memberMobile", this.stateClientDetails()?.memberMobile)
          sessionStorage.setItem("typeOTP", "sms")
        } else {
          sessionStorage.setItem("memberEmail", this.stateClientDetails()?.memberEmail)
          sessionStorage.setItem("typeOTP", "email")
        }

        window.location.href = `/${this.state.client}/${Config.routes.generic.otp_screen}`;

      } else {
        this.setState({
          loading: false,
          loaded: true,
          errorCode: result?.errorCode
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      }, () => {
        this.redirectToLogin();
      })
    })
  }
  async requestOTP() {
    this.setState({
      loading: true
    })
    let payload = {
      "certId": AuthBloc.getCertificateNo(),
      "mbrId": AuthBloc.getNRICNo()
    };

    await AdminBloc.requestOTP(payload).then(async (result) => {
      //console.log("OTP Result", result)
      if (result.success) {
        let otpObject = await this.encryptionData(JSON.stringify(result.data))
        sessionStorage.setItem("otpObject", otpObject)
        if (result.data?.mfaChallengeType == "sms") {
          sessionStorage.setItem("memberMobile", this.stateClientDetails()?.memberMobile)
          sessionStorage.setItem("typeOTP", "sms")
        } else {
          sessionStorage.setItem("memberEmail", this.stateClientDetails()?.memberEmail)
          sessionStorage.setItem("typeOTP", "email")
        }
        window.location.href = `/${this.state.client}/${Config.routes.generic.otp_screen}`;

      } else {
        this.setState({
          loading: false,
          loaded: true
        })
      }
    }).catch((e) => {
      this.setState({
        loading: false,
        loaded: true
      })
    })
  }

  groupButtonsDependOnTypeClient() {
    if (this.stateAction() == "edit") {
      return <div className="d-flex justify-content-center" style={{ gap: "60px" }}>
        <Button
          type="primary"
          className="rounded"
          style={{
            backgroundColor: "#ff7f50",
            borderColor: "#ff7f50",
            height: "42px",
            fontSize: "16px"
          }}
          disabled={this.stateValidated() == true ? false : true}
          onClick={(e) => {
            if (this.stateAction() == "edit") {
              if (this.stateType() == "personal") {
                this.saveClientInformation()
              } else {
                this.saveMemberInformation()
              }
            }
          }}
        >
          <b>Save / <i><strong>Simpan</strong></i></b>
        </Button>

        <div className="text-danger d-flex align-items-center" style={{ cursor: "pointer" }}
          onClick={(e) => {
            if (this.stateAction() == "edit") {
              if (this.stateType() == "personal") {
                window.location.href = `/${this.state.client}/${Config.routes.generic.client_details_screen}/personal/view`
              } else {
                window.location.href = `/${this.state.client}/${Config.routes.generic.documents_screen}`
              }

            }
          }}
        >
          <EditOutlined style={{ fontSize: "20px", marginRight: "8px" }} />
          <span><b>Cancel / <i><strong>Batal</strong></i></b></span>
        </div>
      </div>

    } else {
      return <div className="d-flex justify-content-center" style={{ gap: "60px" }}>
        {
          this.stateClientDetails()?.memberMobile && this.stateClientDetails()?.memberEmail && <Button
            type="primary"
            className="rounded"
            style={{
              backgroundColor: "#ff7f50",
              borderColor: "#ff7f50",
              height: "42px",
              fontSize: "16px",
            }}
            onClick={(e) => {
              this.requestOTP();
            }}
          >
            <b>Request / <i><strong>Minta OTP</strong></i></b>
          </Button>
        }

        {/* <div className="text-danger d-flex align-items-center"
          onClick={() => {
            this.goEditPage();
          }}
          style={{ cursor: "pointer" }}
        >
          <EditOutlined style={{ fontSize: "20px", marginRight: "8px" }} />
          <b>Edit / <i><strong>Tukar</strong></i></b>
        </div> */}
      </div>

    }
  }

  goEditPage() {
    if (this.stateType() == "personal") {
      window.location.href = `/${this.state.client}/${Config.routes.generic.client_details_screen}/personal/edit`
    } else {
      window.location.href = `/${this.state.client}/${Config.routes.generic.member_details_screen}/member/edit`
    }
  }

  render() {
    return <BaseScreen
      errorCode={this.state.errorCode}
    >
      <div className="no-scroll">
        {
          this.loadingContent()
        }
        {
          this.state.loaded && <div className="container mt-5">
            <div className="d-flex align-items-center justify-content-center mb-5">
              <img
                src={
                  GeneralBloc.getAssetsContextPath() +
                  `/assets/images/cuepacs_login_banner.png`
                }
                alt="myCUEPACSCare"
                className="img-fluid"
                style={{ height: "100px" }}
              />
            </div>
            <div className="border rounded shadow-sm p-4">
              {/* Header */}
              {
                this.titleDependOnTypeClient()
              }

              {/* Takaful Certificate */}
              <div className="row">
                <div className="col-md-6">
                  {
                    this.leftContentDependOnTypeClient()
                  }
                </div>
                {
                  (this.stateType() == "member" || this.stateType() == "personal") && this.stateAction() == "view" && this.displayClientDetails()
                }
                {
                  (this.stateType() == "member" || this.stateType() == "personal") && this.stateAction() == "edit" && this.editClientDetails()
                }

              </div>
              {/* Buttons */}
              {
                this.groupButtonsDependOnTypeClient()
              }
            </div>
          </div>
        }

      </div>
    </BaseScreen>

  }
}

export default withRouter(ClientDetailsScreen);
